import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const workflowRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('workflows', {
      create: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Create.vue'),
      edit: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Edit.vue'),
      show: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Show.vue'),
      list: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/List.vue'),
    })
      .permissions({
        create: 'workflows.create',
        edit: 'workflows.update',
        show: 'workflows.view',
        list: 'workflows.view',
      })
      .meta({
        create: { back: 'workflows.list' },
        edit: { back: 'workflows.list' },
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
